import { ProjectSettingModal } from './ProjectSettingModal';
import { withProjectSettingModal } from './withProjectSettingModal';

const ConnectedProjectSettingModal = withProjectSettingModal(
  ProjectSettingModal
);

export { ConnectedProjectSettingModal as ProjectSettingModal };
